<form>
  <div class="row">
    <div class="form-group col-md-4">
      <label for="exampleInputEmail1"> شماره رسید </label>
      <input value="{{Calibration_Device.dsc}}" disabled type="text" class="form-control">
    </div>
    <div class="form-group col-md-4">
      <label for="exampleInputEmail1">
        <button *ngIf="!Calibration_Device.visible" type="button" (click)="openModal(template)" class="btn btn-info">
          نام دستگاه (برای درخواست تغییر نام کلید کنید)
        </button>
        <span *ngIf="Calibration_Device.visible" >نام دستگاه (درخواست تغییر نام دستگاه ثبت شده است)</span>
      </label>
      <input value="{{Calibration_Device.device_name}}" disabled type="text" class="form-control">
    </div>
    <div class="form-group col-md-2">
      <label for="exampleInputEmail1"> زبان گواهی نامه </label>
      <select [(ngModel)]="Calibration_Device.priod" name="priod" class="custom-select">
        <option value="0">فارسی</option>
        <option value="1">انگلیسی</option>
      </select>
    </div>
    <div class="form-group col-md-2">
      <label for="exampleInputEmail1"> نوع گواهی نامه </label>
      <select [(ngModel)]="Calibration_Device.expert_off" name="expert_off" class="custom-select">
        <option value="0">NACI</option>
        <option value="1">NABL</option>
      </select>
    </div>
  </div>
  <div class="row">
    <div class="form-group col-md-4">
      <label for="exampleInputEmail1"> کد دستگاه </label>
      <input [(ngModel)]="Calibration_Device.device_code" name="device_code" placeholder="اینجا تایپ کنید ..."
        type="text" class="form-control">
    </div>
    <div class="form-group col-md-4">
      <label for="exampleInputEmail1"> سریال دستگاه </label>
      <input [(ngModel)]="Calibration_Device.device_serial" name="device_serial" placeholder="اینجا تایپ کنید ..."
        type="text" class="form-control">
    </div>
    <div class="form-group col-md-4">
      <label for="exampleInputEmail1"> مدت انقضاء </label>
      <select [(ngModel)]="Calibration_Device.expiration" name="device_expiration" class="custom-select">

        <option *ngFor="let item of Datalist_Expiration" [value]="item.id">{{item.title}}</option>
      </select>
    </div>
  </div>
</form>

<img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
<button *ngIf="!InProccessing" type="button" (click)="SubmitCalibration()" class="btn btn-success"
  style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> ثبت اطلاعات دستگاه </button>





<ng-template #template>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> درخواست تغییر نام دستگاه </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_RelativeDeviceName.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="table-responsive">
      <table class="mb-0 table table-bordered table-3 text-center table-striped">
        <thead style="background-color: #489b39; color: white;">
          <tr>
            <th>#</th>
            <th>نام دستگاه</th>
            <th>امکانات</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of DataList_RelativeDevice">
            <td>{{DataList_RelativeDevice.indexOf(item)+1}}</td>
            <td>{{item.title}}</td>

            <td>
              <button type="button" (click)="SubmitCalibrationCertificationDevicename(item)" class="btn btn-success">
                انتخاب نام جدید
              </button>
            </td>

          </tr>
        </tbody>
      </table>
    </div>

    <br/>
    <br/>
    <div class="row">
      <div class="form-group col-md-12">
        <label for="exampleInputEmail1">شرح درخواست</label>
        <input [(ngModel)]="Dsc_RelativeDevice" type="text" class="form-control" placeholder="اینجا تایپ کنید ...">
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="modalRef_RelativeDeviceName.hide()">بستن</button>
  </div>
</ng-template>